// extracted by mini-css-extract-plugin
module.exports = {"card":"service-card-blog_card__esQzG","title":"service-card-blog_title__KFPTK","icon":"service-card-blog_icon__abYuf"};